import { render } from "./AddressChangePopup.vue?vue&type=template&id=1352c72a&scoped=true"
import script from "./AddressChangePopup.vue?vue&type=script&lang=js"
export * from "./AddressChangePopup.vue?vue&type=script&lang=js"

import "./AddressChangePopup.vue?vue&type=style&index=0&id=1352c72a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1352c72a"]])

export default __exports__